import React, { useEffect, useState, useRef } from "react";

import ClassNames from "classnames";
import dayjs from "dayjs";
import queryString from "query-string";
import ReactMarkdown from "react-markdown";
import { navigate } from "gatsby";
import H, { HeadingType, WeightType } from "../../../../components/Heading";
import SEO from "../../../../components/seo";
import Layout from "../../../../components/Layout";
import Section from "../../../../components/Section";
import Container from "../../../../components/Container";
import FeaturedBlock from "../../../../components/FeaturedBlock";
import NewsItemCard from "../../../../components/NewsItemCard";
import JSReveal from "../../../../components/JSReveal";
import Select from "../../../../components/Select";
import * as s from "../../../../templates/newsDetails.module.scss";
import newsStaticContent from "../../../../../content/news.json";
import industriesStaticContent from "../../../../../content/industries.json";
import { ContentSEO } from "../../../../partials/Industries/Blogs";
import formStaticContent from "../../../../../content/forms.json";
// Content Data
import {
  getContentData,
  getLocalizedPath,
  getParsedData,
  getSSRData,
  getStaticData,
  scrollToRef,
  getDataByLocaleArticles,
  getLocaleDataForSingleArticle,
} from "../../../../helperFunctions";
import { listBasedOnStatus } from "../../../../helperFunctions";
import { CmsAPI } from "../../../../AxiosInstances";

import Pagination from "@mui/material/Pagination";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ModalRegular from "../../../../components/ModalRegular";
import Button from "../../../../components/Button";
import EnquiryForm from "../../../../partials/Contact/EnquiryForm";

const postPerPage = 12;

const query = (locale, slug) => {
  return `/graphql?query=query {
    articles(
      locale: %22en%22
      filters: {
        published: { eq: true }
        slug: { eq: %22${slug}%22 }
      }
    ) {
      data {
        id
        attributes {
          title
          status
          slug
          category
          createdAt
          slug
          articleOrigin
          articlePublishDate
          articlePublishedAt
          localizations(pagination: { limit: -1 }) {
            data {
              attributes {
                category
                title
                locale
                body
                featuredImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                  IndustryInsightsEBook {
            data {
              attributes {
                url
              }
            }
          }
          industryInsightsDownloadButtonLabel
          formTitle
          tags{
            tag_name
          }
          seo {
            id
            title
            description
            keywords
          }
              }
            }
          }
          body
          youtubeUrl
          featuredImage {
            data {
              attributes {
                url
              }
            }
          }
          IndustryInsightsEBook {
            data {
              attributes {
                url
              }
            }
          }
          industryInsightsDownloadButtonLabel
          formTitle
          tags{
            tag_name
          }
          seo {
            id
            title
            description
            keywords
          }
        }
      }
      meta {
        pagination {
          page
          pageSize
          pageCount
          total
        }
      }
    }
  }`;
};

const queryList = (locale, page) => {
  page = page - 1 < 0 ? 0 : page - 1;
  return `/graphql?query=query {
    articlesList: articles(
      locale: %22en%22
      pagination: { start: ${postPerPage * page}, limit: ${postPerPage} }
      sort: "articlePublishedAt:desc"
      filters: { published: { eq: true }, category: { startsWith: %22FEATURED_ARTICLES%22 } }
    ) {
      data {
        id
        attributes {
          title
          status
          category
          createdAt
          slug
          articleOrigin
          articlePublishDate
          articlePublishedAt
          localizations(pagination: { limit: -1 }) {
            data {
              attributes {
                category
                title
                locale
                body
                featuredImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
          body
          youtubeUrl
          featuredImage {
            data {
              attributes {
                url
              }
            }
          }
          IndustryInsightsEBook {
            data {
              attributes {
                url
              }
            }
          }
          industryInsightsDownloadButtonLabel
          formTitle
          seo {
            id
            title
            description
            keywords
          }
        }
      }
      meta {
        pagination {
          page
          pageSize
          pageCount
          total
        }
      }
    }
  }`;
};

const PageIndustriesBlogs = ({
  pageContext: { locale, alias, htmlLang },
  location,
}) => {
  const search = queryString.parse(location.search);
  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";
  const staging = process.env.GATSBY_ACTIVE_ENV === "staging";
  const production = process.env.GATSBY_ACTIVE_ENV === "production";
  const [articleData, setArticleData] = useState(null);
  const [articleGlobalData, setArticleGlobalData] = useState(null);
  const [articleList, setArticleList] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalArticle, setTotalArticle] = useState(0);
  const [showDetailPage, setShowDetailPage] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [isEbookSent, setIsEbookSent] = useState(false);
  const [responseError, setResponseError] = useState(null);

  const titleRef = useRef(null);
  const pageSEO = getContentData(ContentSEO, "seo", locale);
  const section_title = getContentData(
    ContentSEO,
    "section_title_description",
    locale
  );

  const fetchArticle = async () => {
    CmsAPI.get(query(locale, search.article))
      .then((response) => {
        const data = response?.data?.data?.articles?.data[0];
        fetchMoreArticle(data.id, selectedPage);
        setArticleData(getLocaleDataForSingleArticle(data, locale));
        setArticleGlobalData(data);
      })
      .catch((error) => {
        console.log("response -- error", error.response);
      });
  };

  const fetchMoreArticle = async (id, selectedPage) => {
    CmsAPI.get(queryList(locale, selectedPage))
      .then((response) => {
        const tempList = listBasedOnStatus(
          response?.data?.data?.articlesList.data
        );
        const localeSpecificList = getDataByLocaleArticles(tempList, locale);
        let newList = [];
        tempList.filter(
          (article) => article.id !== id && newList.push(article)
        );
        setArticleList(id ? newList : localeSpecificList);
        setTotalArticle(
          response?.data?.data?.articlesList?.meta?.pagination?.total
        );
      })
      .catch((error) => {
        console.log("response -- error", error);
      });
  };

  useEffect(() => {
    if (search.article) {
      window?.scrollTo(0, 0);
      setShowDetailPage(true);
      fetchArticle();
    } else {
      setShowDetailPage(false);
      fetchMoreArticle(false, selectedPage);
    }
  }, [search.article]);

  const [selectedCategory, setSelectedCategory] = useState(
    industriesStaticContent.category[2]
  );
  const theme = useTheme();
  const isTabletAndDown = useMediaQuery(theme.breakpoints.down("md"));
  const startIndex = (selectedPage - 1) * postPerPage + 1;
  const endIndex = Math.min(
    totalArticle && totalArticle,
    selectedPage * postPerPage
  );

  console.log(
    "hahahah",
    process.env.GATSBY_BUILD_SITE,
    process.env.GATSBY_ACTIVE_ENV
  );

  return (
    <Layout
      locale={locale}
      alias={alias}
      htmlLang={htmlLang}
      location={location}
    >
      <SEO
        lang="en"
        title={
          articleData && showDetailPage
            ? articleData?.attributes?.seo?.title || "Default Title"
            : pageSEO?.title
        }
        description={
          articleData && showDetailPage
            ? articleData?.attributes?.seo?.description || "Default Description"
            : pageSEO?.childStrapiComponentGroupSeoDescriptionTextnode
                ?.description
        }
        keywords={
          articleData && showDetailPage
            ? articleData?.attributes?.seo?.keywords || "Default Keywords"
            : pageSEO?.childStrapiComponentGroupSeoDescriptionTextnode?.keywords
        }
        location={location}
        image={
          articleData && showDetailPage
            ? articleData?.attributes?.featuredImage?.data?.attributes?.url ||
              "Default Image URL"
            : articleData?.attributes?.featuredImage?.data?.attributes?.url
        }
      />

      {articleList && !showDetailPage && (
        <>
          <Section
            className={ClassNames("xs_pt_3", "xs_pb_3", "lg_pt_6", "lg_pb_6")}
          >
            <Container
              indent
              className={s.newsDetailsContainer}
              containerRef={titleRef}
            >
              <JSReveal style={{ position: "relative", zIndex: 1 }}>
                <div className={s.insideHeading}>
                  <H
                    type={HeadingType.H1}
                    size="h2"
                    weight={WeightType.BOLD}
                    color="rvGrey500"
                  >
                    {section_title.title}
                  </H>
                  <Select
                    selectedOption={{
                      label: selectedCategory.label,
                      value:
                        typeof selectedCategory.value === "object"
                          ? getStaticData(selectedCategory.value, locale)
                          : selectedCategory.value,
                    }} // Press Release
                    selectedHolderStyle={{ minWidth: "228px" }}
                    selectContainerStyle={{ marginRight: "0px" }}
                    optionContainerStyle={{
                      minHeight: "auto",
                      height: "210px",
                    }}
                    options={[
                      ...industriesStaticContent.category.map((s) => {
                        let trimD = getStaticData(s.value, locale);
                        if (trimD === "Featured Articles") {
                          trimD = "Feature Articles";
                        }
                        return {
                          value: trimD,
                          label: s.label,
                          link: s.link,
                        };
                      }),
                    ]}
                    onOptionClick={({ ...props }) => {
                      const { selected } = props;
                      navigate(getLocalizedPath(locale, alias, selected.link));
                    }}
                  />
                </div>
                <div className={s.subHead}>
                  <H
                    type={HeadingType.H4}
                    size="h4"
                    weight={WeightType.SEMIBOLD}
                    color="rvGrey500"
                  >
                    {section_title.description}
                  </H>
                </div>
              </JSReveal>
              <JSReveal>
                <div className="newsList">
                  {articleList &&
                    articleList.map((item, index) => {
                      const article = item?.attributes;
                      const url =
                        index > 49
                          ? `/media-center/insights/blogs?article=${article.slug}`
                          : production
                          ? `/media-center/insights/blogs/${article.slug}`
                          : `/media-center/insights/blogs?article=${article.slug}`;
                      return (
                        <NewsItemCard
                          key={article.id}
                          imageUrl={`${process.env.CMS_API_URL}${article?.featuredImage?.data?.attributes?.url}`}
                          imageAlt={article.title}
                          publishedDate={
                            article.articlePublishDate
                              ? dayjs(article.articlePublishDate).format(
                                  "D MMMM YYYY"
                                )
                              : dayjs(article.articlePublishedAt).format(
                                  "D MMMM YYYY"
                                )
                          }
                          title={article.title}
                          category={article.category}
                          to={`${getLocalizedPath(locale, article.alias, url)}`}
                          hideCategory={true}
                        />
                      );
                    })}
                </div>
              </JSReveal>
            </Container>
          </Section>
          <div className={s.contPagination}>
            {isTabletAndDown ? (
              <Pagination
                count={Math.ceil(totalArticle / postPerPage)}
                page={selectedPage}
                onChange={(event, page) => {
                  setSelectedPage(page);
                  fetchMoreArticle(false, page);
                  scrollToRef(titleRef);
                }}
                // Set boundaryCount and siblingCount to limit the number of pages displayed
                boundaryCount={1}
                siblingCount={0}
                sx={{
                  "& .MuiPaginationItem-page.Mui-selected": {
                    backgroundColor: "#fdb51b !important",
                  },
                }}
              />
            ) : (
              <Pagination
                count={Math.ceil(totalArticle / postPerPage)}
                page={selectedPage}
                onChange={(event, page) => {
                  setSelectedPage(page);
                  fetchMoreArticle(false, page);
                  scrollToRef(titleRef);
                }}
                // Show "First" and "Last" buttons on desktop
                showFirstButton={true}
                showLastButton={true}
                sx={{
                  "& .MuiPaginationItem-page.Mui-selected": {
                    backgroundColor: "#fdb51b !important",
                  },
                }}
              />
            )}
            <div className={s.pageIndicator}>
              {`Showing ${startIndex}-${endIndex} of ${totalArticle}`}
            </div>
          </div>
        </>
      )}

      {articleData && showDetailPage && (
        <>
          <Section
            className={ClassNames("xs_pt_3", "xs_pb_3", "lg_pt_6", "lg_pb_6")}
          >
            <Container indent className={s.newsDetailsContainer}>
              <JSReveal>
                <FeaturedBlock
                  smallTitle={
                    <H
                      type={HeadingType.H4}
                      size="h4"
                      weight={WeightType.EXTRABOLD}
                      color="rvGrey500"
                      uppercase
                    >
                      {section_title.title}
                    </H>
                  }
                  header={
                    <H
                      type={HeadingType.H2}
                      size="h1"
                      weight={WeightType.SEMIBOLD}
                      color="rvGrey500"
                    >
                      {getSSRData(
                        articleGlobalData,
                        articleData,
                        "title",
                        locale
                      )}
                    </H>
                  }
                  content={
                    <>
                      {tdcxCN ? (
                        <div className={s.imageWrapper}>
                          <img
                            src={`${process.env.CMS_API_URL}${articleData?.attributes?.featuredImage?.data?.attributes?.url}`}
                            alt={getSSRData(
                              articleGlobalData,
                              articleData,
                              "title",
                              locale
                            )}
                          />
                        </div>
                      ) : articleData?.attributes?.youtubeUrl ? (
                        <div className={s.videoWrapper}>
                          <iframe
                            title="webinar video"
                            src={articleData?.attributes?.youtubeUrl}
                            frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                      ) : (
                        <div className={s.imageWrapper}>
                          <img
                            src={`${process.env.CMS_API_URL}${articleData?.attributes?.featuredImage?.data?.attributes?.url}`}
                            alt={getSSRData(
                              articleGlobalData,
                              articleData,
                              "title",
                              locale
                            )}
                          />
                        </div>
                      )}

                      <H
                        type={HeadingType.H4}
                        size="h5"
                        className={s.date}
                        weight={WeightType.BOLD}
                      >
                        {articleData?.attributes?.articlePublishDate
                          ? dayjs(
                              articleData?.attributes?.articlePublishDate
                            ).format("D MMMM YYYY")
                          : dayjs(
                              articleData?.attributes?.articlePublishedAt
                            ).format("D MMMM YYYY")}
                      </H>
                      <div className={s.newsBody}>
                        <p>
                          {getParsedData(
                            getSSRData(
                              articleGlobalData,
                              articleData,
                              "body",
                              locale
                            )
                          )}
                        </p>

                        <ReactMarkdown
                          renderers={{
                            link: ({ href, children }) => {
                              return (
                                <a
                                  href={href}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  {children}
                                </a>
                              );
                            },
                            image: ({ src, alt }) => {
                              return (
                                <span
                                  style={{
                                    borderRadius: "1rem",
                                    overflow: "hidden",
                                    fontSize: 0,
                                    lineHeight: 0,
                                    marginTop: "1rem",
                                    display: "inline-block",
                                    maxWidth: "100%",
                                  }}
                                >
                                  <img
                                    src={src}
                                    alt={alt}
                                    style={{
                                      width: "auto",
                                      maxWidth: "100%",
                                      paddingBottom: 0,
                                    }}
                                  />
                                </span>
                              );
                            },
                          }}
                        />
                        {getSSRData(
                          articleGlobalData,
                          articleData,
                          "industryInsightsDownloadButtonLabel",
                          locale
                        ) &&
                          getSSRData(
                            articleGlobalData,
                            articleData,
                            "industryInsightsDownloadButtonLabel",
                            locale
                          ) !== "" && (
                            <Button
                              variant="primary"
                              size="large"
                              external={true}
                              onClick={() => {
                                setModalIsOpen(true);
                              }}
                            >
                              {getSSRData(
                                articleGlobalData,
                                articleData,
                                "industryInsightsDownloadButtonLabel",
                                locale
                              )}
                            </Button>
                          )}
                      </div>
                      <ModalRegular
                        isOpen={modalIsOpen}
                        onRequestClose={() => setModalIsOpen(false)}
                      >
                        <div className={s.modalBody}>
                          <div className={s.header}>
                            <div className={s.title}>
                              <H
                                type={HeadingType.H1}
                                size="h1"
                                weight={WeightType.BOLD}
                                className={s.text}
                                color="rvGrey500"
                                style={{ textTransform: "uppercase" }}
                              >
                                {!isEbookSent
                                  ? getSSRData(
                                      articleGlobalData,
                                      articleData,
                                      "formTitle",
                                      locale
                                    )
                                  : getStaticData(
                                      formStaticContent.get_the_free_ebook_download_message,
                                      locale
                                    ).title}
                              </H>
                            </div>
                            <div className={s.description}>
                              <H
                                type={HeadingType.h5}
                                size="h5"
                                weight={WeightType.REGULAR}
                              >
                                {!isEbookSent
                                  ? getStaticData(
                                      formStaticContent.get_the_free_ebook_description,
                                      locale
                                    ).title
                                  : ""}
                              </H>
                            </div>
                          </div>

                          {!isEbookSent &&
                          articleData?.attributes?.IndustryInsightsEBook?.data
                            ?.attributes.url !== "" ? (
                            <EnquiryForm
                              ebook={true}
                              downloadableEbook={`${process.env.CMS_API_URL}${
                                getLocaleDataForSingleArticle(
                                  articleData,
                                  locale
                                ).attributes.IndustryInsightsEBook?.data
                                  ?.attributes.url
                              }${
                                articleData?.attributes?.tags &&
                                articleData?.attributes?.tags.length >= 2
                                  ? articleData?.attributes?.tags[1].tag_name
                                  : ""
                              }`}
                              featuredContact
                              businessEnquiry={false}
                              locale={locale}
                              isSent={isEbookSent}
                              setIsSent={setIsEbookSent}
                              responseError={responseError}
                              setResponseError={setResponseError}
                              selectedEnquiryType="EBOOK"
                              origin="E-Book"
                              ebookTitle={getSSRData(
                                articleGlobalData,
                                articleData,
                                "title",
                                locale
                              )}
                              report={true}
                            />
                          ) : null}
                        </div>
                      </ModalRegular>
                    </>
                  }
                />
              </JSReveal>
            </Container>
          </Section>
        </>
      )}
      {articleList && articleData && showDetailPage && (
        <Section
          variant="sectionBgGrey"
          className={ClassNames(
            "xs_pt_3",
            "xs_pb_2",
            "md_pt_4",
            "md_pb_4",
            "lg_pt_6",
            "lg_pb_6"
          )}
        >
          <Container indent>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <H
                type={HeadingType.H3}
                weight={WeightType.BOLD}
                color="rvGrey500"
              >
                {getStaticData(newsStaticContent.moreArticle, locale)}
              </H>
              <a
                title="See all news"
                href={`/media-center/insights/blogs`}
                className={s.link}
              >
                <strong>
                  {getStaticData(newsStaticContent.see_all, locale)}
                </strong>
              </a>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                marginBottom: "32px",
                marginLeft: "-.5rem",
                marginRight: "-.5rem",
              }}
            >
              {articleList &&
                articleList.slice(0, 3).map((item) => {
                  const article = item?.attributes;
                  return (
                    <NewsItemCard
                      bgWhite
                      key={article.id}
                      imageUrl={`${process.env.CMS_API_URL}${article?.featuredImage?.data?.attributes?.url}`}
                      imageAlt={article.title}
                      publishedDate={dayjs(article.articlePublishedAt).format(
                        "D MMMM YYYY"
                      )}
                      title={
                        getLocaleDataForSingleArticle(item, locale).attributes
                          .title
                      }
                      category={article.category}
                      to={`${getLocalizedPath(
                        locale,
                        article.alias,
                        `/media-center/insights/blogs?article=${article.slug}`
                      )}`}
                      hideCategory={true}
                    />
                  );
                })}
            </div>
          </Container>
        </Section>
      )}
    </Layout>
  );
};

export default PageIndustriesBlogs;
